import { z } from 'zod';

export const ContentSourceRefSchema = z.object({
  type: z.enum(['DESKTOP_LOCAL', 'RENDER_SERVICE_NAS']),
  rootId: z.string(),
  relativePath: z.string(),
});

export type ContentSourceRefType = z.infer<typeof ContentSourceRefSchema>;
